import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { href: '#board', label: '征集令' },
  { href: '#verify', label: '求证工作台' },
  { href: '#steps', label: '提供方式' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于平台' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header
      className={
        'fixed inset-x-0 top-0 z-50 transition-all duration-300 ' +
        (scrolled
          ? 'bg-background-50/95 border-b border-background-200 backdrop-blur'
          : 'bg-transparent border-b border-foreground-50/10')
      }
    >
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={
                'font-heading text-xl font-black tracking-tight ' +
                (light ? 'text-foreground-50' : 'text-foreground-950')
              }
            >
              寻料站
            </span>
            <span
              className={
                'mt-1 text-[10px] font-medium tracking-[0.28em] uppercase ' +
                (light ? 'text-foreground-300' : 'text-foreground-500')
              }
            >
              XunLiao · 线索征集
            </span>
          </span>
        </a>

        <nav
          className={
            'hidden items-center gap-7 md:flex ' +
            (light ? 'text-foreground-200/90' : 'text-foreground-700')
          }
          aria-label="主导航"
        >
          {NAV_LINKS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={
                'whitespace-nowrap text-[14px] font-medium transition-colors ' +
                (light
                  ? 'hover:text-foreground-50 hover:text-primary-300'
                  : 'hover:text-primary-700')
              }
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            href="#submit"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex items-center gap-1.5"
          >
            <i className="ri-broadcast-line" aria-hidden="true"></i>
            我要提供线索
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className={
              'flex h-10 w-10 items-center justify-center rounded-md border transition-colors md:hidden ' +
              (light
                ? 'border-foreground-50/20 text-foreground-50'
                : 'border-background-300 text-foreground-800')
            }
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="md:hidden border-t border-background-200 bg-background-50"
          aria-label="移动端导航"
        >
          <div className="flex flex-col px-4 py-3">
            {NAV_LINKS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3 text-[15px] font-medium text-foreground-800 hover:text-primary-700"
              >
                {item.label}
                <i className="ri-arrow-right-up-line text-foreground-400" aria-hidden="true"></i>
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              <i className="ri-broadcast-line" aria-hidden="true"></i>
              我要提供线索
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}